import { IClientsDataSources, IClientsHasContacts } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions, Equal } from '@llws/dynamic-router-utils';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/client-api/clients/:param/clients_data_sources';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  alias: 'cds',
  select: [
    'cds.id',
    'cds.clientId',
    'cds.lastSuccessful',
    'cds.sourceName',
    'cds.sourceType',
  ],
  where: [
    Equal('cds.active', '1'),
  ],

  orderBy: [
    { field: 'cds.lastSuccessful', direction: 'desc' },
  ],

  limit: 'false',
};

const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IClientsDataSources>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'contacts/'

  state: {
    list: base.state.list,
  },

  getters: {
    list: base.getters.list,
  },

  mutations: {
    setQuery: base.mutations.setQuery,
    set: base.mutations.set,
  },

  actions: {
    get: base.actions.get,
  },
};
